<mat-card
  class="card mat-elevation-z8"
  tabindex="0"
  [class]="exercise.isSelected ? ['contrast', 'accent'] : []"
  >
  <mat-card-title-group>
    <mat-card-title class="card__title">
      <span ftE2e="exerciseName">{{ exercise.name }}</span>
    </mat-card-title>
  </mat-card-title-group>
  <mat-card-content>
    <div class="subtitle-item">
      <p>Muscle</p>
      <p ftE2e="exerciseTargetMuscle">
        {{ muscleLabelsFor(exercise.targetMuscles) | titlecase }}
      </p>
    </div>
    <div class="subtitle-item">
      <p>Equipment</p>
      <p>{{ equipmentLabels[exercise.equipment] }}</p>
    </div>
    <div class="subtitle-item">
      <p>Type</p>
      <p>{{ exerciseTypeLabels[exercise.exerciseType] }}</p>
    </div>
  </mat-card-content>
  <mat-card-actions class="exercise-actions" (click)="$event.stopPropagation()">
    <button
      mat-stroked-button
      color="accent"
      ftE2e="exerciseViewBtn"
      (click)="viewExercise(exercise)"
      >
      View
    </button>

    @if (exercise.canEdit) {
      <button
        mat-stroked-button
        color="primary"
        ftE2e="editExerciseBtn"
        (click)="editExercise(exercise)"
        >
        Edit
      </button>
    }
    @if (exercise.canDelete) {
      <button
        mat-mini-fab
        color="warn"
        ftE2e="deleteExerciseBtn"
        (click)="deleteExercise(exercise)"
        >
        <mat-icon>delete</mat-icon>
      </button>
    }
  </mat-card-actions>
</mat-card>
